// =============================================================================
// PASSWORD INPUT with show/hide toggle
// =============================================================================

import { useState, forwardRef } from 'react';
import { Eye, EyeOff } from './Icons.js';

interface PasswordInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> {
  /** Pass-through for className on the wrapper */
  wrapperClassName?: string;
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ wrapperClassName, className, ...props }, ref) => {
    const [visible, setVisible] = useState(false);

    return (
      <div className={`relative ${wrapperClassName || ''}`}>
        <input
          ref={ref}
          type={visible ? 'text' : 'password'}
          className={`${className || 'input'} pr-10`}
          {...props}
        />
        <button
          type="button"
          onClick={() => { setVisible(!visible); }}
          className="absolute right-2 top-1/2 -translate-y-1/2 p-1.5 text-ink-3 hover:text-ink-1 transition-colors"
          aria-label={visible ? 'Hide password' : 'Show password'}
          tabIndex={-1}
        >
          {visible ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
        </button>
      </div>
    );
  }
);
PasswordInput.displayName = 'PasswordInput';
